import i18n from '../i18n';

export default class ManagementType {
  public static readonly UNDEFINED = new ManagementType('', '');
  // public static readonly UNANSWERED = new ManagementType('0', '全て');
  public static readonly UNANSWERED = new ManagementType('0', '全て（確認完了分除く）');
  public static readonly WAITING = new ManagementType('1', '会員回答待ち');
  public static readonly ACCEPTANCE = new ManagementType('2', 'SLC受付待ち');
  public static readonly VALIDATING = new ManagementType('3', 'SLC確認中');
  public static readonly COMPLETED = new ManagementType('4', '確認完了');
  public static readonly KEEPING = new ManagementType('5', '保管中');

  public static values(): any {
    return [
      { value: this.WAITING.value, text: i18n.t(this.WAITING.text) },
      { value: this.ACCEPTANCE.value, text: i18n.t(this.ACCEPTANCE.text) },
      // { value: this.VALIDATING.value, text: i18n.t(this.VALIDATING.text) },
      { value: this.COMPLETED.value, text: i18n.t(this.COMPLETED.text) },
      { value: this.KEEPING.value, text: i18n.t(this.KEEPING.text) },
    ];
  }

  public static filterValues(): any {
    return [
      { value: this.UNANSWERED.value, text: i18n.t(this.UNANSWERED.text) },
      { value: this.WAITING.value, text: i18n.t(this.WAITING.text) },
      { value: this.ACCEPTANCE.value, text: i18n.t(this.ACCEPTANCE.text) },
      // { value: this.VALIDATING.value, text: i18n.t(this.VALIDATING.text) },
      { value: this.COMPLETED.value, text: i18n.t(this.COMPLETED.text) },
      { value: this.KEEPING.value, text: i18n.t(this.KEEPING.text) },
    ];
  }

  public static valueOf(value: string): ManagementType {
    for (const v of this.values()) {
      if (v.value === value) {
        return v;
      }
    }
    return ManagementType.UNDEFINED;
  }

  private constructor(public readonly value: string, public readonly text: string) {}
  public getValue(): string { return this.value; }
  public getText(): string { return this.text; }
  public equals(other: ManagementType): boolean { return (this.text === other.text) ? true : false; }
  public toString(): string { return `${this.text}(${this.text})`; }
}
